<script>
export default {
    computed: {
        customMessage() {
            return this.$store.getters.CONFIRMED_POPUP_MESSAGE;
        },
    },
    methods: {
        async close() {
            this.$store.commit('SHOP_POPUP_NAME', null);
            this.$store.commit('CONFIRMED_POPUP_MESSAGE', null);
        },
        async confirmed() {
            const confirmedMethod = this.$store.getters.CONFIRMED_POPUP_METHOD;

            await this.close();
            await confirmedMethod();
        },
    },
};
</script>

<template>
    <div class="popup_confirmed_container">
        <div class="popup_header">
            <label class="">Are you sure?</label>
            <button @click="close" class="popup_close_button">X</button>
        </div>
        <hr />
        <label>{{
            customMessage || 'This operation cannot be canceled.'
        }}</label>
        <div class="popup_button_container">
            <button @click="confirmed" class="mt_20">Yes</button>
            <button @click="close" class="mt_10">No</button>
        </div>
    </div>
</template>
